import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaPhoneAlt, FaInstagram } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa6";
import './Footer.css';
import logoVazio from '../../img/logoVazio.png';

function Footer() {
    const navigate = useNavigate();

    const handleNavigation = (id) => {
        navigate('/');
        setTimeout(() => {
            const section = document.getElementById(id);
            if (section) {
                section.scrollIntoView({ behavior: "smooth" });
            }
        }, 100); // Espera 100ms para garantir que a navegação aconteceu
    };

    return (
        <div>
            <footer className="bg-body-tertiary text-center text-lg-start" id="ftr">
                <div className="container p-4">
                    <div className="row">
                        <div className="col-lg-6 col-md-12 mb-4 mb-md-0">
                            <img src={logoVazio} alt="Logo" />
                        </div>
                        <div className="col-lg-3 col-md-12 mb-4 mb-md-0">
                            <p className="nav-item">
                                <a className="nav-link" href="/institucional" style={{textDecoration: 'none', color:'#848D8B'}}>Institucional</a>
                            </p>
                            <p className="nav-item">
                                <a className="nav-link" href="#nascemosParaCuidar" style={{textDecoration: 'none', color:'#848D8B'}} onClick={() => handleNavigation('nascemosParaCuidar')}>Atuação</a>
                            </p>
                            <p className="nav-item">
                                <a className="nav-link" href="/formulario" style={{textDecoration: 'none', color:'#848D8B'}}>Formulário</a>
                            </p>
                        </div>
                        <div className="col-lg-3 col-md-12 mb-4 mb-md-0">
                            <h5 style={{color:'#3E554F'}}>Contato</h5>
                            <p>
                                Endereço:<br />
                                <span style={{textDecoration: 'none', color:'#848D8B', marginBottom:'-10px'}}>Av. João Pinheiro, 639  Centro.</span>
                            </p>
                            <p>
                                Contato:<br />
                                <span style={{textDecoration: 'none', color:'#848D8B'}}><FaPhoneAlt id="phone"/> (34) 99876-0506</span>
                            </p>
                            <p>
                                <span style={{color:'#2CBC95'}}>contato@institutounimeduberlandia.coop.br</span>
                            </p>
                            <p>
                                <a href='https://br.linkedin.com/company/unimeduberlandia' style={{textDecoration: 'none'}}><FaLinkedinIn id="linkedin"/></a> <a href='https://www.instagram.com/institutounimedudi?igsh=dnI3eDZtNTQxYnVx'><FaInstagram id="instagram"/></a>
                            </p>
                            <p>
                                <a href='https://www.unimeduberlandia.coop.br/portal/' style={{textDecoration: 'none', color:'#2CBC95'}}>Grupo Unimed Uberlândia</a>
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Footer;
